/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleOfValuesResponseDto
 */
export interface ScheduleOfValuesResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ScheduleOfValuesResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleOfValuesResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    sovId: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    submissionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    property?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    suburb?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    severity?: ScheduleOfValuesResponseDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    postalZipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    crestaZone: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    occupancy: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    buildingValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    cpe?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    stock?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    pdValue: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    pdDeductibles?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    biValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    biRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    pdRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    longitude?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    constructionClass?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    roofType?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    numberOfStories?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    yearBuilt?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    fluvialFlood?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    originalStormSurge?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    originalPfRiskLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    windstorm?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    hailstorm?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    wildfire?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    locationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesResponseDto
     */
    totalInsurableValue: string;
}


/**
 * @export
 */
export const ScheduleOfValuesResponseDtoSeverityEnum = {
    Low: 'Low',
    Average: 'Average',
    High: 'High'
} as const;
export type ScheduleOfValuesResponseDtoSeverityEnum = typeof ScheduleOfValuesResponseDtoSeverityEnum[keyof typeof ScheduleOfValuesResponseDtoSeverityEnum];


/**
 * Check if a given object implements the ScheduleOfValuesResponseDto interface.
 */
export function instanceOfScheduleOfValuesResponseDto(value: object): value is ScheduleOfValuesResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('sovId' in value) || value['sovId'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('crestaZone' in value) || value['crestaZone'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('occupancy' in value) || value['occupancy'] === undefined) return false;
    if (!('pdValue' in value) || value['pdValue'] === undefined) return false;
    if (!('locationNumber' in value) || value['locationNumber'] === undefined) return false;
    if (!('totalInsurableValue' in value) || value['totalInsurableValue'] === undefined) return false;
    return true;
}

export function ScheduleOfValuesResponseDtoFromJSON(json: any): ScheduleOfValuesResponseDto {
    return ScheduleOfValuesResponseDtoFromJSONTyped(json, false);
}

export function ScheduleOfValuesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleOfValuesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'sovId': json['sovId'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
        'fileId': json['fileId'],
        'property': json['property'] == null ? undefined : json['property'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'suburb': json['suburb'] == null ? undefined : json['suburb'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalZipCode': json['postalZipCode'] == null ? undefined : json['postalZipCode'],
        'crestaZone': json['crestaZone'],
        'country': json['country'],
        'occupancy': json['occupancy'],
        'buildingValue': json['buildingValue'] == null ? undefined : json['buildingValue'],
        'cpe': json['cpe'] == null ? undefined : json['cpe'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'pdValue': json['pdValue'],
        'pdDeductibles': json['pdDeductibles'] == null ? undefined : json['pdDeductibles'],
        'biValue': json['biValue'] == null ? undefined : json['biValue'],
        'biRate': json['biRate'] == null ? undefined : json['biRate'],
        'pdRate': json['pdRate'] == null ? undefined : json['pdRate'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'constructionClass': json['constructionClass'] == null ? undefined : json['constructionClass'],
        'roofType': json['roofType'] == null ? undefined : json['roofType'],
        'numberOfStories': json['numberOfStories'] == null ? undefined : json['numberOfStories'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'fluvialFlood': json['fluvialFlood'] == null ? undefined : json['fluvialFlood'],
        'originalStormSurge': json['originalStormSurge'] == null ? undefined : json['originalStormSurge'],
        'originalPfRiskLevel': json['originalPfRiskLevel'] == null ? undefined : json['originalPfRiskLevel'],
        'windstorm': json['windstorm'] == null ? undefined : json['windstorm'],
        'hailstorm': json['hailstorm'] == null ? undefined : json['hailstorm'],
        'wildfire': json['wildfire'] == null ? undefined : json['wildfire'],
        'locationNumber': json['locationNumber'],
        'totalInsurableValue': json['totalInsurableValue'],
    };
}

export function ScheduleOfValuesResponseDtoToJSON(json: any): ScheduleOfValuesResponseDto {
    return ScheduleOfValuesResponseDtoToJSONTyped(json, false);
}

export function ScheduleOfValuesResponseDtoToJSONTyped(value?: ScheduleOfValuesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'sovId': value['sovId'],
        'submissionId': value['submissionId'],
        'fileId': value['fileId'],
        'property': value['property'],
        'streetAddress': value['streetAddress'],
        'suburb': value['suburb'],
        'severity': value['severity'],
        'state': value['state'],
        'postalZipCode': value['postalZipCode'],
        'crestaZone': value['crestaZone'],
        'country': value['country'],
        'occupancy': value['occupancy'],
        'buildingValue': value['buildingValue'],
        'cpe': value['cpe'],
        'stock': value['stock'],
        'pdValue': value['pdValue'],
        'pdDeductibles': value['pdDeductibles'],
        'biValue': value['biValue'],
        'biRate': value['biRate'],
        'pdRate': value['pdRate'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'constructionClass': value['constructionClass'],
        'roofType': value['roofType'],
        'numberOfStories': value['numberOfStories'],
        'yearBuilt': value['yearBuilt'],
        'fluvialFlood': value['fluvialFlood'],
        'originalStormSurge': value['originalStormSurge'],
        'originalPfRiskLevel': value['originalPfRiskLevel'],
        'windstorm': value['windstorm'],
        'hailstorm': value['hailstorm'],
        'wildfire': value['wildfire'],
        'locationNumber': value['locationNumber'],
        'totalInsurableValue': value['totalInsurableValue'],
    };
}

